import { Button, ArrowDown, ArrowUp } from '@doda/io-react/common';
import classnames from 'classnames';
import { useState, FC } from 'react';
import { useCountUpdateAnimation } from 'hooks/useCountUpdateAnimation';
import { UpperLimitErrorText } from 'components/UpperLimitErrorText';
import styles from './index.module.scss';

const CONTENT_HEIGHT = {
  OPEN_HEIGHT: 0,
  CLOSE_HEIGHT: 'calc(100% - 24px)',
} as const;

type ContentTypeUnion = (typeof CONTENT_HEIGHT)[keyof typeof CONTENT_HEIGHT];

/**
 * Props
 * @param totalCount 求人件数
 * @param isOpacity 透明か
 * @param isInvisible 表示されているか
 * @param onClickSearchButton 検索ボタン押下時の処理
 * @param validationFlags バリデーションに関するオブジェクト
 */
interface Props {
  totalCount: number;
  isOpacity: boolean;
  isInvisible: boolean;
  onClickSearchButton: () => void;
  validationFlags?: {
    isIncomeRangeError?: boolean;
    isConditionUpperLimitError?: boolean;
  };
}

export const OverlaySearchArea: FC<Props> = ({
  totalCount,
  isOpacity,
  isInvisible,
  onClickSearchButton,
  validationFlags = {},
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [contentHeight, setContentHeight] = useState<ContentTypeUnion>(
    CONTENT_HEIGHT.OPEN_HEIGHT
  );

  const { isIncomeRangeError = true, isConditionUpperLimitError = true } =
    validationFlags;

  const countAnimationRef = useCountUpdateAnimation(totalCount);

  const onToggle = () => {
    if (isOpen) {
      setContentHeight(CONTENT_HEIGHT.OPEN_HEIGHT);
    } else {
      setContentHeight(CONTENT_HEIGHT.CLOSE_HEIGHT);
    }
    setIsOpen((pre) => !pre);
  };

  return (
    <div
      className={classnames(styles['overlay-search-area__layout'], {
        [styles['is-opacity']]: isOpacity,
        [styles['is-invisible']]: isInvisible,
      })}
      style={{ transform: `translateY(${contentHeight})` }}
    >
      <div className={styles['overlay-search-area__inner']}>
        <button
          type="button"
          className={styles['overlay-search-area__arrow-button']}
          onClick={onToggle}
        >
          {isOpen ? (
            <ArrowUp size="M" color="white" />
          ) : (
            <ArrowDown size="M" color="white" />
          )}
        </button>
        {!isConditionUpperLimitError && <UpperLimitErrorText />}
        <p className={styles['overlay-search-area__total']}>
          この条件の求人数
          <span
            className={styles['overlay-search-area__number']}
            ref={countAnimationRef}
          />
          件
        </p>
        <Button
          variant="green"
          size="S"
          widthPercentage={100}
          onClick={onClickSearchButton}
          disabled={!isIncomeRangeError || !isConditionUpperLimitError}
        >
          検索する
        </Button>
      </div>
    </div>
  );
};
